export { default as Home } from './Home';
export { default as AboutUs } from './AboutUs';
export { default as Contact } from './Contact';
export { default as NewsEvent } from './NewsEvent';
export { default as NewsEventReadMore } from './NewsEventReadMore';
export { default as Products } from './Products';
export { default as Policy } from './Policy';



// WEBPACK FOOTER //
// ./src/screens/index.js